import { useState } from "react";
import { Link } from "react-router-dom";
import BarDeretourSetting from "../../../components/BarDeretourSetting";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
import "./ChangePassword.css";

export default function ChnageMailAdmin() {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <>
            <NewSideBarAdmin />
            <div className="container mt-5 settings-container">
                <BarDeretourSetting />
                <div className="card-form-wrapper">
                    <div className="card-form-header">
                        <div className="icon-wrapper">
                            <i className="bi bi-envelope-at"></i>
                        </div>
                        <h5>Changer l'adresse email</h5>
                        <p className="card-form-subtitle">Mettez à jour votre adresse email pour la gestion de votre compte.</p>
                    </div>

                    <form className="card-form-body" onSubmit={(e) => e.preventDefault()}>
                        <div className="form-group mb-3">
                            <label className="form-label">Email actuel</label>
                            <div className="input-icon-group">
                                <i className="bi bi-envelope input-icon"></i>
                                <input type="email" className="form-control custom-input" placeholder="nom@exemple.com" />
                            </div>
                        </div>

                        <div className="form-group mb-3">
                            <label className="form-label">Mot de passe actuel</label>
                            <div className="input-icon-group">
                                <i className="bi bi-lock input-icon"></i>
                                <input 
                                    type={showPassword ? "text" : "password"} 
                                    className="form-control custom-input" 
                                    placeholder="••••••••" 
                                />
                                <i 
                                    className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"} toggle-eye-icon`} 
                                    onClick={() => setShowPassword(!showPassword)}
                                    title={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                                ></i>
                            </div>
                        </div>

                        <div className="form-group mb-4">
                            <label className="form-label">Nouvel email</label>
                            <div className="input-icon-group">
                                <i className="bi bi-envelope-plus input-icon"></i>
                                <input type="email" className="form-control custom-input" placeholder="nouveau@exemple.com" />
                            </div>
                        </div>

                        <button type="submit" className="btn-submit-custom">Valider la modification</button>

                        <div className="form-footer-link">
                            <Link to="#">Besoin d'aide ? Contactez-nous</Link>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}